// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"stepSubheader_pageHeading__2rLo1","pageNumber":"stepSubheader_pageNumber__2Y0pQ","totalPages":"stepSubheader_totalPages__IY-UN"};